import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class VendorDashboardService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }


  // GET SERVICES
  GetVendorDashboard(userId: String,appType:String, financialYear:String) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=${userId}&AppType=${appType}&financialYear=${financialYear}`, { headers: this.buildHeaders()});
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=1`);
  }

  getFarmerDashboardDataForVendor(vendorMobile:String){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerDashboardDataForVendor?VendorMobile=` + vendorMobile, { headers: this.buildHeaders() });
  }

  getComponentMaster(){
    return this.http.get(environment.apiUrl + 'FarmerApplication/GetComponentMaster');
  }

  getAllMIVendors(ProgramId){
    return this.http.get(`${environment.apiUrl}FarmerApplication/GetAllMIvenders?ProgramId=${ProgramId}`);
  }

  getCategory(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCategoryMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}`);
  }

  getCategoryMasterVendorReg(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetCategoryMasterVendorReg?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}`);
  }

  getComponentTypeByProgIdEPC(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetComponentTypeByProgIdEPC?ProgId=${reqBody.ProgId}&Area=${reqBody.Area}`);
  }

  getDistinctSpacingEPC(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetDistinctSpacingEPC?ProgId=${reqBody.ProgId}&Area=${reqBody.Area}&ComponentType=${reqBody.ComponentType}`);
  }

  getDistinctPipeSizeBySpacingEPC(reqBody){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetDistinctPipeSizeBySpacingEPC?ProgId=${reqBody.ProgId}&Area=${reqBody.Area}&ComponentType=${reqBody.ComponentType}&Spacing=${reqBody.Spacing}`);
  }

  getDistinctPressureEPC(reqBody){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetDistinctPressureEPC?ProgId=${reqBody.ProgId}&Area=${reqBody.Area}&ComponentType=${reqBody.ComponentType}&Spacing=${reqBody.Spacing}&PipeSize=${reqBody.PipeSize}`);
  }

  getComponentRateWiseEpc(reqBody){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetComponentRateWiseEpc?ProgId=${reqBody.ProgId}&Area=${reqBody.Area}&Spacing=${reqBody.Spacing}&PipeSize=${reqBody.PipeSize}&ComponentType=${reqBody.ComponentType}&Pressure=${reqBody.Pressure}&Outlet=${reqBody.Outlet}`);
  }

  getComponent(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetComponentMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}`);
  }

  getComponentMasterVendorReg(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetComponentMasterVendorReg?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}`);
  }

  getCMLNumber(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Department/GetComponentMasterCML?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}&CompId=${reqBody.CompId}`);
  }

  getSizeAndPrice(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetSizePriceMaster?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}&ComponentId=${reqBody.ComponentId}`);
  }

  getSizePriceMasterVendorReg(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/getSizePriceMasterVendorReg?VendorRegId=${reqBody.VendorRegId}&ProgramId=${reqBody.ProgramId}&CategoryId=${reqBody.CategoryId}&ComponentId=${reqBody.ComponentId}`);
  }

  getVendorMIEstimation(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${reqBody.AppId}&VendorRegId=${reqBody.VendorRegId}&ProgId=${reqBody.ProgramId}`);
  }

  getMIEstimationDetailsForAppProgId(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetMIEstimationDetailsForAppProgId?AppID=${reqBody.AppId}&ProgramID=${reqBody.ProgramId}`);
  }

  predictestimatesPDMC(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/predictestimatesPDMC?VendorId=${reqBody.VendorId}&ProgId=${reqBody.ProgId}&Area=${reqBody.Area}`, {});
  }

  getCropMaster(){
    return this.http.get<any>(`${environment.apiUrl}LandDetails/GetCropMaster`);
  }

  getChallanForVendor(UserId, FinYear){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetChallanForVendor?UserId=${UserId}&FinYear=${FinYear}`);
  }
  
  //POST SERVICES
  postVendorMIEstimationDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}DashBoard/InsertVendorMIEstimationDetail`, reqBody);
  }

  getMaxSubsidyEstimate(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/getMaxSubsidyEstimate`, reqBody);
  }
  
  getCenterStateShareCalc(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Department/GetCenterStateShareCalc`, reqBody);
  }

  insertChallanAcknowledgement(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertChallanAcknowledgement`, reqBody);
  }

  updateCMLValidity(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Department/UpdateCMLValidity`, reqBody);
  }

  // DELETE SERVICE
  deleteEstimation(reqBody){
    // AppId=1&VendorId=1&ProgId=1
    return this.http.delete<any>(`${environment.apiUrl}DashBoard/DeleteVendorMIEstimation?AppId=${reqBody.AppId}&VendorId=${reqBody.VendorRegId}&ProgId=${reqBody.ProgramId}`);
  }

  //UPDATE SERVICES
  updateVendorEstimationDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}DashBoard/UpdateVendorMIEstimation`, reqBody);
  }

  GetPreEstimationSurvey(userId: String, AppType: String, financialyear: String) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationsForMIPreEstimation?UserId=${userId}&AppType=${AppType}&financialyear=${financialyear}`, { headers: this.buildHeaders() });
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIEstimation?UserId=1`);
  }

  vendorGrievanceStatus(vendorCode: any) {
    return this.http.get<any>(`${environment.apiUrl}MICADAgrievance/GetVendorGrievanceByVendorCode?Vendor_Code=${vendorCode}`, { headers: this.buildHeaders() });
  }

  farmerGrievanceStatus(mobNo: any) {
    return this.http.get<any>(`${environment.apiUrl}MICADAgrievance/GetFarmerGrievanceByMobile?Mobile_No=${mobNo}`, { headers: this.buildHeaders() });
  }

  getCategories() {
    return this.http.get<any>(`${environment.apiUrl}MICADAgrievance/GetCategories`, { headers: this.buildHeaders() });
  }

  submitGrievance(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}MICADAgrievance/FarmerSubmitGrievance`, reqBody);
  }

  getProDataSpacing(MiId):any{
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetDistinctSpacing?ProgId=${MiId}`, { headers: this.buildHeaders() });
  }

  GetEditPreEstimationSurvey(reqBody):any{
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetApplicationDataOfPreEstimation?AppId=${reqBody.AppId}&ProgId=${reqBody.ProgramId}`, { headers: this.buildHeaders() });
  }
  insertVendorInventoryDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertInventoryPurchaseDetail`, reqBody);
  }
  
  insertUploadedGSTDetail(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertUploadedGSTDetail`, reqBody);
  }

  getInventoryPurchaseDetail(userId){
    return this.http.get(`${environment.apiUrl}Vendor/GetInventoryPurchaseDetail?UserId=${userId}`);
  }

  deleteInventoryPurchaseDetail(reqBody){
    return this.http.delete<any>(`${environment.apiUrl}Vendor/DeleteInventoryPurchaseDetail?autoId=${reqBody.autoId}&userID=${reqBody.userID}&network_Id=${reqBody.network_Id}&terminal_Id=${reqBody.terminal_Id}`);
  }

  updateInventoryPurchaseDetail(reqBody:any){
    return this.http.put<any>(`${environment.apiUrl}Vendor/UpdateInventoryPurchaseDetail`, reqBody);
  }

  insertFarmerDataByContractor(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertFarmerDataByContractor`, reqBody);
  }
  
  deleteVendorAssociates(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/DeleteVendorAssociates`, reqBody);
  }

  insertVendorAssociates(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertVendorAssociates`, reqBody);
  }

  insertVendorAssociateApprovalStatus(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/InsertVendorAssociateApprovalStatus`, reqBody);
  }

  updateFarmerPersonalDetails(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/UpdateFarmerPersonalDetails`, reqBody);
  }

  deleteFarmerPersonalDetails(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/DeleteFarmerPersonalDetailsEPC`, reqBody);
  }
  
  getEPCDetails(agreementNo, outletId, chunkId, userId){
    return this.http.get(`${environment.apiUrl}Vendor/GetEPCDetails?AgreementNo=${agreementNo}&OutletId=${outletId}&ChunkId=${chunkId}&User=${userId}`);
  }

  getContractorEstimation(contractorId, outletId, agreementNo, chunkId){
    return this.http.get(`${environment.apiUrl}Vendor/GetContractorEstimation?ContractorId=${contractorId}&OutletId=${outletId}&AgreementNo=${agreementNo}&ChunkId=${chunkId}`);
  }

  insertContractorEstimation(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertContractorEstimation`, reqBody);
  }
  insertVendorComponentDetails(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Vendor/InsertVendorComponentDetails`, reqBody);
  }

  insertComponentPriceEPC(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/InsertComponentPriceEPC`, reqBody);
  }

  insertReVerificationEPC(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/InsertReVerificationEPC`, reqBody);
  }

  insertGeoAndAttachmentsEPC(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/InsertGeoAndAttachmentsEPC`, reqBody);
  }

  // getLandOwnersDetail(reqBody){
  //   return this.http.get(`${environment.apiUrl}LandDetails/GetLandOwners/${reqBody.distCode}/${reqBody.tehsilCode}/${reqBody.villCode}/0/${reqBody.killaNo}/JSON`);
  // }

  getLandOwnersDetail(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetLandOwnersList`, reqBody);
  }

  getLandGetAreaByKhewat(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetLandGetAreaByKhewat`, reqBody);
  }

  getKhasraAreaKhewatByNVCODE2Khewat(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetKhasraAreaKhewatByNVCODE2Khewat`, reqBody);
  }

  getGeoDetailsByVillCode(villageCode){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetGeoDetailsByVillCode?VillCode=${villageCode}`);
  }

  // getLandKhewatByKhasra(reqBody){
  //   return this.http.get(`${environment.apiUrl}LandDetails/GetLandKhewatByKhasra/${reqBody.distCode}/${reqBody.tehsilCode}/${reqBody.villCode}/0/${reqBody.killaNo}/JSON`);
  // }

  getLandKhewatByKhasra(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetLandOwnerskanalDetails`, reqBody);
  }

  getKhewatByKhasra(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetKhewatByKhasra`, reqBody);
  }

  updateKhewatByLandId(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/UpdateKhewatByLandId`, reqBody);
  }

  getLandGetAreaByKhasra(reqBody){
    return this.http.post<any>(`${environment.apiUrl}LandDetails/GetLandGetAreaByKhasra`, reqBody);
  }

  getGeoAndAttachmentsEPC(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetGeoAndAttachmentsEPC?AppId=${reqBody?.AppId}&ProgId=${reqBody?.ProgId}&ChunkId=${reqBody?.ChunkId}`);
  }

  getContractorMaster(userId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetContractorMaster?UserId=${userId}`);
  }

  getDivisionMasterEPC(userId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetDivisionMasterEPC?UserId=${userId}`);
  }

  getAllAppIdsByVendor(userId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetAllAppIdsByVendor?VendorMobile=${userId}`);
  }

  getEstimationDetailsByUserIDEPC(userId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetEstimationDetailsByUserID_EPC?UserID=${userId}`);
  }

  getVendorProgMaster(emailId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetVendorProgMaster?Email=${emailId}`);
  }

  getVendorRegCompMaster(emailId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetVendorRegCompMaster?Email=${emailId}`);
  }

  getVendorApprovalDetails(emailId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetVendorApprovalDetails?Email=${emailId}`);
  }

  getVendorRegProgPriceMaster(){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetVendorRegProgPriceMaster`);
  }

  getVendorRegNamesForApproval(){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetVendorRegNamesForApproval`);
  }

  getVendorRegCompDetailsForApproval(vendorId){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetVendorRegCompDetailsForApproval?VendorId=${vendorId}`);
  }

  getVendorRegTypeMaster(){
    return this.http.get<any>(`${environment.apiUrl}vendor/GetVendorRegTypeMaster`);
  }

  getAssociateWorkType(){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetAssociateWorkType`);
  }

  getVendorsForAssociateApproval(){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetVendorsForAssociateApproval`);
  }

  getAssociatesByVendorId(vendorId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetAssociatesByVendorId?VendorId=${vendorId}`);
  }
}